export default function ColumnDefinition() {
  return null;
}

ColumnDefinition.displayName = "ColumnsArrangement.ColumnDefinition";
